import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from './svg/dynamic_price.svg'

const DynamicPriceIcon: React.VFC<SvgIconProps> = props => <SvgIcon component={Icon} {...props} fill="currentColor" />
export default DynamicPriceIcon
